import { useEffect, useRef } from 'react';
import ChartsEmbedSDK from '@mongodb-js/charts-embed-dom';
import { Box } from '@mui/material';

const MONGO_CHARTS_BASE_URL = process.env?.REACT_APP_MONGO_CHARTS_BASE_URL || '';

type RenderDashboardProps = {
  dashboardId: string;
  authToken: string;
  companyId: string;
};

const RenderDashboard = ({ dashboardId, authToken, companyId }: RenderDashboardProps) => {
  const dashboardRef = useRef(null);

  useEffect(() => {
    if (authToken && dashboardRef.current) {
      const sdk = new ChartsEmbedSDK({
        baseUrl: MONGO_CHARTS_BASE_URL,
        getUserToken: () => authToken,
      });

      const dashboard = sdk.createDashboard({
        dashboardId,
        showAttribution: false,
        showTitleAndDesc: false,
        filter: {
          companyId:
            process.env?.REACT_APP_ENVIRONMENT === 'LOCAL' ||
            process.env?.REACT_APP_ENVIRONMENT === 'TEST'
              ? '40865'
              : companyId,
        },
        heightMode: 'fixed',
        widthMode: 'scale',
        background: 'transparent',
      });

      dashboard
        .render(dashboardRef.current)
        .catch((err) => console.error('Error loading dashboard:', err));
    }
  }, [authToken, dashboardId, companyId]);

  return (
    <Box
      ref={dashboardRef}
      sx={{
        height: '100vh',
        pb: 0,
      }}
    />
  );
};

export default RenderDashboard;
